export const API_URL =
  import.meta.env.VITE_ENVIRONMENT === 'local'
    ? 'http://localhost:8080'
    : import.meta.env.VITE_ENVIRONMENT === 'development'
      ? 'https://backend-fjpawwlada-ez.a.run.app'
      : import.meta.env.VITE_ENVIRONMENT === 'ci'
        ? import.meta.env.VITE_BACKEND_URL || 'http://localhost:8080'
        : import.meta.env.VITE_ENVIRONMENT === 'staging'
          ? 'https://ets-nav.com'
          : 'https://app.ets-navigator.com';
